import AlertBox from "components/global/AlertBox";
import sampleDashboard from "assets/images/authBackground.webp";
import styled from "styled-components";
import googleIcon from "assets/icons/googleIcon.svg";
import { initialState } from "api/rootReducer";
// import appleIcon from "assets/icons/appleIcon.svg";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  overflow: hidden;

  .contentLeft {
    position: relative;
  }

  .contentRight {
    background-color: var(--white);
    padding: 60px 72px 24px;
    position: relative;
    height: 100vh;
    overflow: auto;

    .header {
      display: flex;
      justify-content: space-between;
    }

    .description {
      color: #4e4b66;
    }
  }

  .sampleDashboard {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .forgotPassword {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    overflow: auto;

    .contentLeft {
      display: none;
    }

    .contentRight {
      padding: 4.8rem 2.4rem;

      h3 {
        font-size: 24px;
        line-height: 32px;
      }
    }

    .title-1 {
      font-size: 14px;
      line-height: 20px;

      a {
        font-size: 14px;
      }
    }

    .linkBottomRight {
      width: calc(100% - 48px);
      margin: auto;
      right: unset;

      a {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .bold {
    font-weight: 700;
    color: var(--secondary);
  }
`;

export const AuthProviderButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: var(--white);
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  transition: var(--transition_default);
  margin-bottom: 12px;
  width: 100%;
  padding: 14px;

  &:last-of-type {
    margin-bottom: 24px;
  }

  &:hover {
    background-color: var(--background);
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  position: relative;

  .text {
    position: relative;
    padding: 6px;
    background-color: var(--white);
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    lwft: 0;
    width: 100%;
    height: 1px;
    background-color: var(--grey_10);
  }
`;

export const authProviders = [
  {
    name: "google",
    buttonText: "Continue with Google",
    target: `${initialState.api_host}auth/google`,
    icon: googleIcon,
  },
  // {
  //   name: "apple",
  //   buttonText: "Continue with Apple",
  //   target: `auth/apple`,
  //   icon: appleIcon,
  // },
];

const AuthLayout = ({ children }) => {
  return (
    <Wrapper>
      <AlertBox />
      <div className="contentLeft">
        <img
          src={sampleDashboard}
          alt="Sample dashboard"
          className="sampleDashboard"
        />
      </div>
      <div className="contentRight">{children}</div>
    </Wrapper>
  );
};

export default AuthLayout;
